import React from 'react';

const InclineArrow = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg ref={ref} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M6.11091 5.88909H13.8891M13.8891 5.88909V13.6673M13.8891 5.88909L6.11091 13.6673"
        stroke="#212112"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
);

InclineArrow.displayName = 'InclineArrow';

export default InclineArrow;
